define('modules/emblue/view',['require','exports','module','views/BaseView','env','ldsh!./template','ldsh!./template','ldsh!./template_savenewcps','ldsh!./template_showphoneform'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView"),
    Config = require("env");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),
    emblue: null,
    returnUrl: false,
    events: {
      "click #goToBack": "goToBack",
    },

    beforeRender: function () {
      var migrationStatus = this.emblue && this.emblue.get("migrationStatus");

      if (this.options.tab === "showphoneform" && migrationStatus != null) {
        this.template = require("ldsh!./template");
      }
    },
    afterRender: function () {
      BaseView.prototype.afterRender.call(this);
      var migrationStatus = this.emblue && this.emblue.get("migrationStatus");
      if (this.options.tab === "showphoneform" && migrationStatus == null) {
        this.initForm();
      }
    },

    initialize: function (options) {
      if (options.tab === "savenewcps") {
        this.template = require("ldsh!./template_savenewcps");
      }
      if (options.tab === "showphoneform") {
        this.template = require("ldsh!./template_showphoneform");
      }
    },

    serialize: function () {
      if (this.options.tab === "savenewcps") {
        return {};
      }
      var migrationStatus = this.emblue.get("migrationStatus");
      var migrationPhone = this.emblue.get("migrationPhone");

      if (this.options.tab === "showphoneform" && migrationStatus == null) {
        return {
          migrationPhone: migrationPhone,
        };
      }

      if (migrationStatus.status == 0) {
        return {
          status: false,
        };
      }

      if (migrationStatus.status == 1 || migrationStatus.status == 3) {
        return {
          status: migrationStatus.status,
          groupId: migrationStatus.groupId,
          email: this.findEmailinInfo(migrationStatus.info),
          phone: migrationPhone,
        };
      }

      return {
        status: migrationStatus.status,
      };
    },

    findEmailinInfo: function (info) {
      const resultado = info.find(
        (item) => item.data && item.data.status === 0
      );

      if (resultado) {
        return resultado.data.email;
      } else {
        return "unknown";
      }
    },
    goToBack: function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location = this.returnUrl;
    },
    initForm: function () {
      var self = this;

      $("#form-migration-phone")
        .bootstrapValidator({
          onSuccess: function (e) {
            $("#submitButton").prop("disabled", true);
            self.save();
          },
          onError: function (e) {
            self.render();
          },
          fields: {
            migrationPhone: {
              validators: {
                notEmpty: {
                  message:
                    $.i18n.t("FORM.VALIDATION.TXT_MANDATORY_FIELD") + "ggg",
                },
                callback: {
                  callback: function (value, validator, $field) {
                    const regex = /^\+[1-9]\d{1,14}$/;
                    if (!regex.test(value)) {
                      return {
                        valid: false,
                        message: $.i18n.translate(
                          "FORM.VALIDATION.TXT_PHONE_NUMBER_FORMAT"
                        ),
                      };
                    }
                    return true;
                  },
                },
              },
            },
          },
        })
        .on("error.field.bv", function (e, data) {
          var that = $(e.target);
        });
    },
    save: function () {
      var self = this;
      var form = $("#form-migration-phone");
      var data = {};

      form.serializeArray().map(function (item) {
        data[item.name] = item.value;
      });

      this.emblue.set(data);
      this.emblue.save(null, {
        success: function (model, response) {
          console.info("success");
          self.render();
        },
        error: function (model, response) {
          console.info("error");
        },
      });
    },
  });

  module.exports = Layout;
});

